import React, { useEffect, useState } from 'react';
import { meses, tipoReporte } from '../../catalogos';
import { generateToken, IsNotNullOrEmptyOrUndefined, renderInput, ValidarEmisor, ValidarLogin } from '../../util';
import InputField from '../nuevoDocumento/InputField';
import configFile from "../../apis/configFile.json";
import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import RenderHeader from '../shared/RenderHeader';

var years = [];

const Reportes = (props) => {

    const { token } = ValidarLogin(props);
    const { emisor } = ValidarEmisor(props);
    const [mesActual, setMesActual] = useState(null);
    const [reporteD, setReporteD] = useState({
        mercancia: 2500000,
        servicio: 50000,
        fechaInicio: (new Date().getFullYear() - 1) + '-09-30',
        fechaFin: (new Date().getFullYear()) + '-10-01',
    });
    const [casaMatriz, setCasaMatriz] = useState('001');
    const [facturasEnvCon, setFacturasEnvCon] = useState({
        tipoReporte: 1,
        mes: '0' + new Date().getMonth(),
        anno: new Date().getFullYear()
    });

    useEffect(() => {

        if (token !== null && emisor !== null) {

            let cm = emisor.usuario.split("-");
            if (cm?.length > 1) {
                setCasaMatriz(cm[1]);
            }
            getMesActual();
            getAnoActual();
        }

    }, [emisor, token])

    if (token === null || emisor === null) {
        return <Redirect to='/login' />;
    }

    const getAnoActual = () => {
        for (let index = new Date().getFullYear(); index >= 2018; index--) {
            years.push(index);
        }
    }

    const getMesActual = () => {
        meses.filter(meses => {
            if (parseInt(meses.value) === (new Date().getMonth())) {
                setMesActual(meses.value)
            }
        })
    }

    const handleSubmitFacturas = (event) => {
        event.preventDefault();
        let token = generateToken(emisor?.Identificacion?.Numero).substring(0, 15);
        if (facturasEnvCon.tipoReporte === 1) {
            window.open(configFile.agileBillingServicesURL + `/consultarFactura/GetEnviadasPorMes?cedula=${emisor?.Identificacion?.Numero}-${casaMatriz}&anno=${facturasEnvCon.anno}&mes=${facturasEnvCon.mes}&token=${token}`);
        } else if (facturasEnvCon.tipoReporte === 2){
            window.open(configFile.agileBillingServicesURL + `/consultarFactura/GetConfirmadasPorMes?cedula=${emisor?.Identificacion?.Numero}-${casaMatriz}&anno=${facturasEnvCon.anno}&mes=${facturasEnvCon.mes}&token=${token}`);
        } else if (facturasEnvCon.tipoReporte === 3){
            window.open(configFile.agileBillingServicesURL + `/consultarFactura/GetImpuestoNetoPorMes?cedula=${emisor?.Identificacion?.Numero}-${casaMatriz}&anno=${facturasEnvCon.anno}&mes=${facturasEnvCon.mes}&token=${token}`);
        }
    }

    const handleSubmitReporte = (event) => {
        event.preventDefault();
        let token = generateToken(emisor?.Identificacion?.Numero).substring(0, 15);
        window.open(configFile.agileBillingServicesURL + `/consultarFactura/GetD151Report?cedula=${emisor?.Identificacion?.Numero}&fechaInicio=${reporteD.fechaInicio}&fechaFin=${reporteD.fechaFin}&montoMaxiMercancias=${reporteD.mercancia}&montoMaxServicios=${reporteD.servicio}&token=${token}`);
    }

    const handleInputChange = (input) => {
        setReporteD({
            ...reporteD,
            ...input
        })

    }

    const handledSelect = (option) => {

        if (parseFloat(option.mes) < 10) {
            let mesTemp = '0' + option.mes;
            option.mes = mesTemp;
        }
        setFacturasEnvCon({
            ...facturasEnvCon,
            ...option
        })
    }

    const setFormatDateInicio = (value) => {
        if (IsNotNullOrEmptyOrUndefined(value)) {
            let fecha = new Date(value);
            let fechaString = fecha.getUTCFullYear() + "-" + (fecha.getUTCMonth() + 1) + "-" + fecha.getDate();
            setReporteD({
                ...reporteD,
                fechaInicio: fechaString
            })
        }
    };

    const setFormatDateFin = (value) => {
        if (IsNotNullOrEmptyOrUndefined(value)) {
            let fecha = new Date(value);
            let fechaString = fecha.getUTCFullYear() + "-" + (fecha.getUTCMonth() + 1) + "-" + fecha.getDate();
            setReporteD({
                ...reporteD,
                fechaFin: fechaString
            })
        }
    };

    return (
        <>

            <div className="ui Lista-facturas-container">

                <RenderHeader titulo="REPORTES" />

                <div className="titulo-reportes">
                    <h4>Facturas enviadas y confirmadas</h4>
                </div>

                <form onSubmit={handleSubmitFacturas} className="ui form" >

                    <div className="ui stackable four column grid">
                        <div className="column data-picker" >
                            <strong>Año</strong>
                            <select onChange={(e) => handledSelect({ anno: parseFloat(e.target.value) })} className="ui fluid dropdown">
                                {
                                    years.map(year =>
                                        <option key={year} value={year} >{year}</option>
                                    )
                                }
                            </select>
                        </div>
                        <div className="column">
                            <InputField
                                label="Mes"
                                type="select"
                                options={meses}
                                value={mesActual}
                                onChange={(e) => handledSelect({ mes: e.target.value })}
                            />
                        </div>
                        <div className="column">
                            <InputField
                                label="Tipo de Reporte"
                                type="select"
                                options={tipoReporte}
                                onChange={(e) => handledSelect({ tipoReporte: parseFloat(e.target.value) })}
                            />
                        </div>
                        <div className="column container-btn">
                            <button value="Submit" type="submit" className="ui primary button active download-button " >
                                <i className="cloud download icon"></i>
                                Descargar
                            </button>
                        </div>
                    </div>

                </form>

                <hr />

                <div className="titulo-reportes">
                    <h4>Reporte D-151</h4>
                </div>

                <form onSubmit={handleSubmitReporte} className="ui form" >

                    <div className="ui stackable five column grid">
                        <div className="column" >
                            <InputField
                                label="Del"
                                value={reporteD.fechaInicio}
                                type="datePicker"
                                placeholder="DD-MM-YYYY"
                                onChange={(e) => setFormatDateInicio(e?._d)}
                            />
                        </div>
                        <div className="column" >
                            <InputField
                                label="Hasta"
                                value={reporteD.fechaFin}
                                type="datePicker"
                                placeholder="DD-MM-YYYY"
                                onChange={(e) => setFormatDateFin(e?._d)}
                            />
                        </div>
                        <div className="column">
                            <InputField
                                label="Monto Máximo Mercancía"
                                type="number"
                                component={renderInput}
                                name="mercancia"
                                onChange={(e) => handleInputChange({ mercancia: parseFloat(e.target.value) })}
                                value={reporteD.mercancia}
                            />
                        </div>
                        <div className="column">
                            <InputField
                                label="Monto Máximo Servicio"
                                type="number"
                                component={renderInput}
                                onChange={(e) => handleInputChange({ servicio: parseFloat(e.target.value) })}
                                value={reporteD.servicio}
                            />
                        </div>
                        <div className="column container-btn">
                            <button value="Submit" type="submit" className="ui primary button active download-button " >
                                <i className="cloud download icon"></i>
                                Descargar
                            </button>
                        </div>
                    </div>

                </form>

            </div>

        </>
    );
};

const mapStateToProps = (state) => {
    return {
        initialValues: state.localFormState,
        loginState: state.loginState,
        emisorState: state.emisorState,
    };
}

export default connect(mapStateToProps, {})(Reportes);